
import { ElForm } from 'element-ui/types/form'
import { Vue, Component } from 'vue-property-decorator'
import UploadImg from '@/common/class/UploadImg'

/**
 * @emit create 创建新推荐线索
*/

@Component({})
export default class ClueCreateDialog extends Vue {
    private imgFile: File | undefined | null = null
    private loadingMsg = '加载中'
    private isLoading = false
    private visible = false
    private imgLoad = false
    private clueForm: any = { 
        img: '',
        title: '', 
        url: '', 
        order: '',
        publish: ''
    }
    private previewSrc = ''
    private clueRules = {
        img: [
            { required: true, validator: this.imgValidator }
        ],
        title: [
            { required: true, message: '请输入标题' }
        ],
        url: [
            { required: true, validator: this.urlValidtor }
        ],
        order: [
            { required: true, validator: this.orderValidtor }
        ],
        publish: [
            { required: true, message: '请选择发表时间' }
        ]
    }
    private copy: any = {}

    get fileEl() {
        return this.$refs.file as HTMLElement
    }
    get formRef() {
        return this.$refs.clueForm as ElForm
    }
    get dialogBody() {
        return document.querySelector('.el-dialog__body') as HTMLElement
    }
    /* ---------------------- 分界线 ---------------------- */
    private show() {
        this.visible = true
    }
    private hide() {
        this.reset()
        this.visible = false
    }
    private onfileSelect() {
        this.fileEl.click()
    }
    private isUrl(value: string) {
        const reg = /^(?:(http|https|ftp):\/\/)?((?:[\w-]+\.)+[a-z0-9]+)((?:\/[^/?#]*)+)?(\?[^#]+)?(#.+)?$/i
        return reg.test(value)
    }
    private onDialogClose(done: Function) {
        if (this.isLoading) return
        this.reset()
        done()
    }
    private onUpdate() {
        // 完成所有操作，直接返回参数
        this.formRef.validate(async (isValid: boolean) => {
            if (!isValid) return
            // 上传图片
            if (this.imgFile) {
                const key = await this.uploadImg()
                ;(this.fileEl as any).value = ''
                if (!key) {
                    return false
                }
                this.clueForm.img = key
            }
            this.showLoading('创建新线索中')
            this.$emit('create', this.clueForm)
        })
    }
    private onCancel() {
        if (this.isLoading) return
        this.reset()
        this.visible = false
    }
    private hideLoading() {
        this.isLoading = false
    }
    private reset() {
        this.dialogBody.scrollTop = 0
        this.imgFile = null
        this.imgLoad = false
        this.isLoading = false
        this.previewSrc = ''
        this.clueForm = { id: null , img: '', title: '', url: '', order: '' }
        this.formRef.resetFields()
    }
    private imgValidator(rule: any, value: any, callback: Function) {
        if (this.clueForm.img) callback()
        if (!this.imgFile) {
            callback(new Error('请选择上传图片'))
        }
        callback()
    }
    private onFileChange(e: Event) {
        const file = (e.target as any).files[0] 
        this.imgFile = file
        this.previewSrc = URL.createObjectURL(file)
        this.clueForm.img = this.previewSrc
        this.formRef.validateField('img')
    }
    private urlValidtor(rule: any, value: any, callback: Function) {
        let message = '请输入正确的链接地址'
        if (!value) callback(new Error(message))
        if (!this.isUrl(value)) {
            callback(new Error(message))
        }
        callback()
    }
    private orderValidtor(rule: any, value: any, callback: Function) {
        let message = '请输入正确的序号'
        // 检验是否 number 类型
        const isNumber = Number.isInteger(+value)
        if (!isNumber) {
            return callback(message)
        }
        callback()
    }
    private async uploadImg() {
        // 上传图片
        if (!this.imgFile) { 
            this.$message({ type: 'warning', message: '发生错误, 请稍后再试' })    
            return false
        }
        const uploadImg = new UploadImg(this.imgFile)
        this.showLoading('上传图片中')
        const uploadImgRes: any = await uploadImg.upload()
        if (uploadImgRes.error) {
            this.$message({ type: 'warning', message: '图片上传失败, 请稍后再试' })
            return false
        }
        return uploadImgRes.key
    }
    private showLoading(msg = '加载中') {
        if (msg) {
            this.loadingMsg = msg
        }
        this.isLoading = true
    }
    private hasUpdate() {
        for (let key in this.copy) {
            if (this.copy[key] !== this.clueForm[key]) {
                return true
            }
        }
        return false
    }
}
